import { useReducer, useEffect } from "react";
import {
  SET_CLIENTS_LIST,
  SET_DEFAULT_INSTALLATION,
  SET_NOMENCLATURES_LIST,
  SET_SITES_LIST,
} from "../constants";
import installationEditFormReducer from "../reducer/InstallationEditFormReducer";
import useInstallationEditFormFetchData from "./useInstallationEditFormFetchData";

export default function useInstallationEditFormState(
  sitesList,
  getSitesList,
  clientsList,
  getClientsList,
  nomenclaturesList,
  getNomenclatures,
  info
) {
  const [state, dispatch] = useReducer(installationEditFormReducer, {});

  useInstallationEditFormFetchData(
    sitesList,
    getSitesList,
    clientsList,
    getClientsList,
    nomenclaturesList,
    getNomenclatures
  );

  useEffect(() => {
    dispatch({ type: SET_SITES_LIST, payload: sitesList });
  }, [sitesList]);

  useEffect(() => {
    dispatch({ type: SET_CLIENTS_LIST, payload: clientsList });
  }, [clientsList]);

  useEffect(() => {
    dispatch({ type: SET_NOMENCLATURES_LIST, payload: nomenclaturesList });
  }, [nomenclaturesList]);

  useEffect(() => {
    if (info) {
      const payload = {
        client: info.client.uuid,
        site: info.site.uuid,
        externalId: info.externalId,
        designation: info.designation,
        mark: info.mark,
        lastLeakDetectionDate: info.lastLeakDetectionDate
          ? new Date(info.lastLeakDetectionDate)
          : info.lastLeakDetectionDate,
        integratedLeakDetector: info.integratedLeakDetector ?? false,
        fluidCode: info.fluid.uuid,
        currentLoad: info.currentLoad,
        nominalLoad: info.nominalLoad,
        components: info.components,
        interventions: info.interventions,
        addedComponents: [],
      };
      dispatch({ type: SET_DEFAULT_INSTALLATION, payload });
    }
  }, [info]);

  return [state, dispatch];
}
